import { render } from "./DashboardCard.vue?vue&type=template&id=d34cd10c"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__